import { Module } from "vuex";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";
import { EmailData } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: EmailData = getDefaultState();
const namespaced: boolean = true;

export const emails: Module<EmailData, RootState> = {
	namespaced,
	state,
	getters,
	mutations,
	actions
};
